import { render, staticRenderFns } from "./ZipList.vue?vue&type=template&id=0c6ce52f&scoped=true&"
import script from "./ZipList.vue?vue&type=script&lang=ts&"
export * from "./ZipList.vue?vue&type=script&lang=ts&"
import style0 from "./ZipList.vue?vue&type=style&index=0&id=0c6ce52f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ce52f",
  null
  
)

export default component.exports